import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=139e2be0&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./scss/roles.scss?vue&type=style&index=0&id=139e2be0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e2be0",
  null
  
)

export default component.exports